import {
  CheckoutAbTestMetricToOptimize,
  CheckoutAbTestTreatmentSchema,
} from "@redotech/redo-conversion-core-common/checkouts/checkout-ab-test-builder";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createCheckoutSplitFromBuilder = {
  name: "createCheckoutSplitFromBuilder" as const,
  input: z.object({
    testName: z.string(),
    testHypothesis: z.string(),
    metricToOptimize: createEnum(CheckoutAbTestMetricToOptimize),
    controlTreatment: CheckoutAbTestTreatmentSchema,
    variantTreatments: z.array(CheckoutAbTestTreatmentSchema),
    enableSplit: z.boolean(),
  }),
  output: z.null(),
};
